module.exports = __webpack_public_path__ + "static/media/image6.d04a5c7f.png";